import { Paper, Typography, styled } from '@mui/material';

import PieChart from '@common/assets/icons/pieChart.svg';

export const StyledProgramCollapseButtonWrap = styled(Paper)({
	borderRadius: '10px',
	padding: '13px 16px 11px 13px',
	maxWidth: '340px',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'space-between',
	gap: '4px',
	cursor: 'pointer',
});

export const StyledProgramCollapseButtonText = styled(Typography)(({ theme }) => ({
	[theme.breakpoints.down('sm')]: {
		display: 'none',
	},
}));

type StyledProgramCollapseButtonIconProps = {
	isCollapsed?: boolean;
};

export const StyledProgramCollapseButtonIcon = styled(PieChart, {
	shouldForwardProp: (prop) => prop !== 'isCollapsed',
})<StyledProgramCollapseButtonIconProps>(({ theme, isCollapsed }) => ({
	transition: 'all .3s',
	color: isCollapsed ? theme.palette.text?.helper : theme.palette.primary.main,
}));
